module.exports = __webpack_public_path__ + "img/huahzhuologo.518255eb.png";